import React from 'react'
import { Ticker, Block } from '@components'

const DatoCmsTicker = ({
  paddingTop,
  paddingBottom,
  background,
  backgroundStyle,
  ...props
}) => {
  return (
    <Block
      gutters
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      background={background}
      backgroundStyle={backgroundStyle}
    >
      <Ticker {...props} />
    </Block>
  )
}

export default DatoCmsTicker
